import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Rechercher/Ajouter un Patient", -1)
const _hoisted_3 = {
  key: 0,
  class: "w-100 d-block d-md-flex align-items-center"
}
const _hoisted_4 = {
  key: 1,
  class: ""
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "pb-2 mt-4 default" }, "Informations sur le patient selectionné: ", -1)
const _hoisted_6 = { class: "container default" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user text-secondary mx-1" }, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user text-secondary mx-1" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-address-book text-secondary mx-1" }, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days text-secondary mx-1" }, null, -1)
const _hoisted_19 = { class: "row border-bottom-dashed" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-person text-secondary mx-1" }, null, -1)
const _hoisted_22 = { class: "col" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days text-secondary mx-1" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mx-2 cursor-pointer",
  for: "patient"
}, " Confirmé le patient sélectionné ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-square" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label mx-2 cursor-pointer",
  for: "patient"
}, " Confirmé le patient sélectionné ", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  key: 2,
  class: "d-flex justify-content-center mt-4"
}

import VueMultiselect from 'vue-multiselect'
import PatientService from '@/_services/PatientService';
import { useStore } from 'vuex'
import { ref, onMounted, computed } from 'vue';

const datas = "user"

// const DataPatient = async (find: "") => {
//     await PatientService.searchPatient(find).then((res: any) => {
//       const patientData: any = res.data
//       searchData.value = patientData.data.map((item: any) => {
//         return {
//           date_de_naissance: item.date_de_naissance,
//           sexe: item.sexe,
//           age: item.age,
//           nom: item.user?.nom,
//           prenom: item.user?.prenom,
//           user_id: item.user_id,
//         };
//       })
//       console.log("res==>", searchData.value);
//       return searchData.value
//     }).catch((error: any) => {
//       console.log("error ", error)
//     })
//   }

export default /*#__PURE__*/_defineComponent({
  __name: 'RecherchePatient',
  props: {
  dialogVisible: Boolean,
},
  setup(__props) {

const store = useStore();

const isLoading = ref(false);

const find = ref([])
const searchData: [] | any = ref([])
let display = store.state.composable.display;
const dialogVisible = ref(false)
function closeModal() {
  display = !display
}

const DataPatient = (find: "") => {
  isLoading.value = true;
  store.dispatch('patient/searchPatient', find);
  searchData.value = store.state.patient.patient;
  isLoading.value = false;
}

function SelectPatient(id: 0, associations: "") {
  store.dispatch('patient/fetchPatient', { id: id, associations: associations });
}

const patientSelect = ref(false)
const confirmPatient = (patient: "") => {
  patientSelect.value = true
}

const props = __props


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    datas
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(VueMultiselect), {
            modelValue: find.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((find).value = $event)),
            options: searchData.value,
            "preserve-search": true,
            placeholder: "Rechercher un Patient",
            label: "nom",
            "preselect-first": false,
            onSearchChange: DataPatient,
            loading: isLoading.value,
            onSelect: _cache[1] || (_cache[1] = ($event: any) => (confirmPatient(find.value)))
          }, null, 8, ["modelValue", "options", "loading"])
        ]))
      : _createCommentVNode("", true),
    (find.value.user_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", null, [
                  _hoisted_9,
                  _createTextVNode("Nom: "),
                  _createElementVNode("strong", null, _toDisplayString(find.value.nom), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", null, [
                  _hoisted_12,
                  _createTextVNode("Prenom: "),
                  _createElementVNode("strong", null, _toDisplayString(find.value.prenom), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", null, [
                  _hoisted_15,
                  _createTextVNode("Adresse: "),
                  _createElementVNode("strong", null, _toDisplayString(find.value.user_id), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", null, [
                  _hoisted_18,
                  _createTextVNode("Date de Naissance: "),
                  _createElementVNode("strong", null, _toDisplayString(find.value.date_de_naissance), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", null, [
                  _hoisted_21,
                  _createTextVNode("Sexe: "),
                  _createElementVNode("strong", null, _toDisplayString(find.value.sexe), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", null, [
                  _hoisted_23,
                  _createTextVNode(" Age: "),
                  _createElementVNode("strong", null, _toDisplayString(find.value.age), 1)
                ])
              ])
            ]),
            (!patientSelect.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ((patientSelect.value = true))),
                  class: "form-check p-0 cursor-pointer my-2"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(['primary', "fa-regular fa-square-check"])
                  }),
                  _hoisted_24
                ]))
              : _createCommentVNode("", true),
            (patientSelect.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (SelectPatient(find.value.user_id, datas), (patientSelect.value = false))),
                  class: "form-check p-0 cursor-pointer my-2"
                }, _hoisted_27))
              : _createCommentVNode("", true),
            (!patientSelect.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    onClick: closeModal,
                    to: "/TeleconsultationForm",
                    class: "btn btn-primary py-2 shadow"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Continuer vers le formulaire")
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})